import { useEffect, useState } from 'react';

const NARROW_VIEWPORT_MQ = '(max-width: 519px)';

/** True on mobile widths where carousel cards need flat layout (no clip). */
export function useNarrowViewport(): boolean {
  const [isNarrow, setIsNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(NARROW_VIEWPORT_MQ).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(NARROW_VIEWPORT_MQ);
    const onChange = (event: MediaQueryListEvent) => setIsNarrow(event.matches);
    setIsNarrow(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isNarrow;
}
